import { ReactNode, useEffect } from 'react';
import { SelectClinicalTrialView } from '@components/LoginSelections/SelectClinicalTrialView';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { routesPath } from '@router/routes';
import { useNavigate } from 'react-router-dom';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';
import { prepareUrl } from '@utils/routerHelpers';

const roleConfig: Record<
  string,
  { urlPath: string; title: string | null; subtitle?: ReactNode }
> = {
  [UserRoles.IMAGING_SPECIALIST]: {
    urlPath: routesPath.qcTasks,
    title: 'QC',
  },
  [UserRoles.READER]: {
    urlPath: routesPath.readerClinicalTrial,
    title: 'Reading',
  },
  [UserRoles.SPONSOR]: {
    urlPath: routesPath.sponsorPages,
    title: '',
    subtitle: (
      <span>
        View your <span className='text-vividTangelo'>Clinical trial</span>{' '}
        data
      </span>
    ),
  },
  [UserRoles.SITE]: {
    urlPath: routesPath.subject,
    title: 'Visits',
  },
  [UserRoles.VALIDATION_SPECIALIST]: {
    urlPath: routesPath.validationSpecialistSubjectsClinicalTrial,
    title: 'Validation Specialist',
  },
  [UserRoles.EXTERNAL_USER]: {
    urlPath: routesPath.externalUserSubjectsClinicalTrial,
    title: 'Subjects',
  },
};
export const SelectClinicalTrialForRole = () => {
  const navigate = useNavigate();
  const clearData = useClinicalTrialContextSlice(
    (state, actions) => actions.clearData
  );
  const selectedRole = useAuthSlice(s => s.data?.selectedRole);

  useEffect(() => {
    clearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!selectedRole) {
    return null;
  }

  const config = roleConfig[selectedRole] ?? {};
  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    navigate(prepareUrl(config.urlPath, [clinicalTrial.id]));
  };
  return (
    <SelectClinicalTrialView
      onSelect={handleSelectCT}
      subTitle={
        config.subtitle ?? (
          <>
            Manage your{' '}
            <span className='text-vividTangelo'>{config.title}</span> tasks
          </>
        )
      }
    />
  );
};
